module.exports = __webpack_public_path__ + "img/202.87db9947.jpg";